import { EnterpriseSolutionDetail } from '@types';
import { useEnterpriseSolution, useUserInput } from '@store';

export const useSelectedSolution = (): EnterpriseSolutionDetail | undefined => {
	const solutions = useEnterpriseSolution();
	const { solutionId } = useUserInput();

	return solutions && solutionId ? solutions.find((solution) => solution.id === solutionId) : undefined;
};
